import Grades from "../grades/GradesPage";
import Permissions from "../permissions/Permissions";
import Access from "./access-tab/Access";
import Advisor from "./advisor-tab/Advisor";
import AllowanceSettings from "./allowance-tab/AllowanceSettings";
import Bank from "./bank-tab/Bank";
import Departments from "./departments-tab/Departments";
import General from "./general-tab/General";
import Integrations from "./integrations-tab/Integrations";
import LeaveRules from "./leave-tab/LeaveRules";
import LeaveSettings from "./leave-tab/LeaveSettings";
import LeaveTypes from "./leave-tab/LeaveTypes";
import OvertimeSettings from "./overtime-tab/OvertimeSettings";
import ReportSettings from "./report-tab/ReportSettings";
import PayScheduleSettings from "./pay-schedule-tab/PayScheduleSettings";
import Payroll from "./payroll-tab/Payroll";
import Pensions from "./pensions-tab/Pensions";
import TimeAndAttendanceRules from "./time-attendance-tab/TimeAndAttendanceRules";
import TimeAndAttendanceSettings from "./time-attendance-tab/TimeAndAttendanceSettings";
import WorkLocationSettings from "./work-locations-tab/WorkLocationSettings";

export function getSettingsTabs({ jurisdiction }) {
	return [
		{
			name: "General",
			tabs: [DetailsTab, AdvisorTab, BankTab],
		},
		{
			name: "Connections",
			tabs: [
				// HMRCTab,
				IntegrationsTab,
			],
		},
		{
			name: "Configuration",
			tabs: [
				DepartmentsTab,
				PaySchedulesTab,
				{
					...AllowancesTab,
					name: jurisdiction === "MT" ? "Allowances & Deductions" : AllowancesTab.name,
				},
				OvertimeTab,
				ReportTab,
				// GradesTab,
			],
		},
		{
			name: "Rules",
			tabs: [PayrollTab, TimesheetsTab, LeaveTab, WorkLocationsTab, PensionsTab],
		},
		{
			name: "Security",
			tabs: [PermissionsTab, AccessTab],
		},
	];
}

export function getSettingsRoutes(tabs, props) {
	if (!tabs && props) tabs = getSettingsTabs(props);

	return tabs
		.flatMap((tab) => {
			if (tab.tabs) {
				return tab.tabs;
			}
			return tab;
		})
		.flatMap((tab) => {
			if (tab.subTabs) {
				return tab.subTabs;
			}
			return tab;
		});
}

const DetailsTab = {
	name: "Details",
	icon: "BookOpenIcon",
	link: "/details",
	default: true,
	component: General,
};

const AdvisorTab = {
	name: "Advisor",
	icon: "ViewColumnsIcon",
	link: "/advisor",
	component: Advisor,
	show: ({ isAdmin, isAdvisor }) => isAdmin || isAdvisor,
};

const IntegrationsTab = {
	name: "Integrations",
	icon: "BoltIcon",
	link: "/integrations",
	component: Integrations,
};

const HMRCTab = {
	name: "HMRC",
	icon: "CrownIcon",
	link: "/hmrc",
	component: General,
	show: ({ jurisdiction }) => ["UK"].includes(jurisdiction),
};

const BankTab = {
	name: "Bank",
	icon: "BuildingLibraryIcon",
	link: "/bank",
	component: Bank,
};

const DepartmentsTab = {
	name: "Departments",
	icon: "RectangleStackIcon",
	link: "/departments",
	component: Departments,
};

const PaySchedulesTab = {
	name: "Pay Schedules",
	icon: "ChevronDoubleRightIcon",
	link: "/pay-schedules",
	component: PayScheduleSettings,
};

const AllowancesTab = {
	name: "Pay Items & Deductions",
	icon: "ChartPieIcon",
	link: "/pay-items",
	component: AllowanceSettings,
};

const OvertimeTab = {
	name: "Overtime & Special Rates",
	icon: "Battery100Icon",
	link: "/overtime",
	component: OvertimeSettings,
};

const ReportTab = {
	name: "Reports",
	icon: "DocumentIcon",
	link: "/report",
	component: ReportSettings,
};

const GradesTab = {
	name: "Grades",
	icon: "TableCellsIcon",
	link: "/grades",
	component: Grades,
};

const PayrollTab = {
	name: "Payroll",
	icon: "CalculatorIcon",
	link: "/payroll",
	component: Payroll,
};

const TimesheetsTab = {
	name: "Timesheets",
	icon: "ClockIcon",
	link: "/timesheets",
	subTabs: [
		{
			name: "Settings",
			link: "/timesheets/settings",
			component: TimeAndAttendanceSettings,
		},
		{
			name: "Rules",
			link: "/timesheets/rules",
			component: TimeAndAttendanceRules,
		},
	],
	component: TimeAndAttendanceSettings,
};

const LeaveTab = {
	name: "Leave",
	icon: "CalendarIcon",
	link: "/leave",
	subTabs: [
		{
			name: "Settings",
			link: "/leave/settings",
			component: LeaveSettings,
		},
		{
			name: "Types",
			link: "/leave/types",
			component: LeaveTypes,
		},
		{
			name: "Rules",
			link: "/leave/rules",
			show: ({ isBeta }) => isBeta,
			component: LeaveRules,
		},
	],
	component: LeaveSettings,
};

const WorkLocationsTab = {
	name: "Work Locations",
	icon: "BuildingOfficeIcon",
	link: "/work-locations",
	component: WorkLocationSettings,
};

const PensionsTab = {
	name: "Pensions",
	icon: "PiggyBankIcon",
	link: "/pensions",
	component: Pensions,
	show: ({ jurisdiction }) => ["UK"].includes(jurisdiction),
};

const PermissionsTab = {
	name: "Permissions",
	icon: "FingerPrintIcon",
	link: "/permissions",
	component: Permissions,
};

const AccessTab = {
	name: "Access",
	icon: "LockClosedIcon",
	link: "/access",
	component: Access,
};
